var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a94370dc-fa7f-4edf-be10-c7ef0c7c2175",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 369.1084 124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a0d9b5da-13e1-4e51-9d0f-d5303c14f4b7",
    x1: 1055.5498,
    y1: 1376.2328,
    x2: 1121.3974,
    y2: 1427.6786,
    gradientTransform: "translate(0 -964)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2843,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6049,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7204,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8027,
    stopColor: "#ebebec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8693,
    stopColor: "#dcdedf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#caccce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9758,
    stopColor: "#b4b6b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b73a5b8f-3dba-4bfe-8472-3c0f474ccab8",
    x1: 1069.7676,
    y1: 1392.6773,
    x2: 1040.2076,
    y2: 1392.6773,
    gradientTransform: "translate(-1022.0785 -1364.3272)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4418,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6918,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7819,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8461,
    stopColor: "#ebebec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#dcdedf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9425,
    stopColor: "#caccce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9811,
    stopColor: "#b4b6b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a5fe7a2d-f295-434e-b767-936655382144",
    x1: 1049.1963,
    y1: 1448.1944,
    x2: 1073.6293,
    y2: 1464.0614,
    gradientTransform: "translate(-1022.0785 -1364.3272)",
    xlinkHref: "#a0d9b5da-13e1-4e51-9d0f-d5303c14f4b7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b5177b46-7e8c-449a-9647-468353528476",
    x1: 1054.7701,
    y1: 1452.2623,
    x2: 1041.0845,
    y2: 1429.4853,
    gradientTransform: "translate(-1022.0785 -1364.3272)",
    xlinkHref: "#a0d9b5da-13e1-4e51-9d0f-d5303c14f4b7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ea0ab2fd-9d7c-46b6-a50a-91c41a54ceee",
    x1: 1446.6785,
    y1: 1430.7272,
    x2: 1446.6785,
    y2: 1430.7272,
    xlinkHref: "#a0d9b5da-13e1-4e51-9d0f-d5303c14f4b7"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1137.5785,524.3273h-106.8a8.6856,8.6856,0,0,1-8.7-8.6v-106.8a8.6215,8.6215,0,0,1,8.7-8.6h106.8a8.6856,8.6856,0,0,1,8.7,8.6v106.8A8.8182,8.8182,0,0,1,1137.5785,524.3273Z",
    transform: "translate(-1022.0785 -400.3272)",
    style: {
      fill: "#212b54"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1128.0785,444.2273v10.9l-14,5.6-44.5-18.4-28.4-11.7,28.4-15.7,47.9,17.2C1123.3785,434.2273,1128.0785,439.7273,1128.0785,444.2273Z",
    transform: "translate(-1022.0785 -400.3272)",
    style: {
      fill: "url(#a0d9b5da-13e1-4e51-9d0f-d5303c14f4b7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.3785,478.7272v30.7l.5.3,50-22c5.7-2.5,10.3-8.2,10.3-12.8v-19.8l-14.5,5.6Z",
    transform: "translate(-1022.0785 -400.3272)",
    style: {
      fill: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.6 14.7 47.6 42 18.1 30.3 47.6 14.7",
    style: {
      fill: "url(#b73a5b8f-3dba-4bfe-8472-3c0f474ccab8)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.3 78.4 45.3 109.4 19.2 96 45.3 78.4",
    style: {
      fill: "url(#a5fe7a2d-f295-434e-b767-936655382144)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.2 96 19.2 65 45.3 78.4 19.2 96",
    style: {
      fill: "url(#b5177b46-7e8c-449a-9647-468353528476)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1181.7352,429.8763A119.4758,119.4758,0,0,1,1201.8,428.35c12.899,0,21.8052,2.834,28.1524,8.502,6.6538,5.7763,10.749,14.4961,10.749,27.03,0,13.0791-4.1973,22.8886-10.749,29.21-6.8589,6.6484-17.813,10.0274-31.2232,10.0274a129.2688,129.2688,0,0,1-16.9936-.9805Zm12.5913,62.2353a44.0585,44.0585,0,0,0,6.9614.3272c16.3794.1084,26.1045-9.4834,26.1045-28.12.1026-16.24-8.7016-25.5059-24.4668-25.5059a37.9271,37.9271,0,0,0-8.5991.7637Z",
    transform: "translate(-1022.0785 -400.3272)",
    style: {
      fill: "#212b54"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.1434,424.971h12.6943v31.6084h.2046a17.3566,17.3566,0,0,1,6.2446-6.1035,16.28,16.28,0,0,1,8.5992-2.3975c8.497,0,17.4033,5.9942,17.4033,22.9971v31.2813h-12.5918V472.6019c0-7.7383-2.6616-13.5156-9.6231-13.5156-4.9135,0-8.3945,3.4882-9.7251,7.5205a11.9692,11.9692,0,0,0-.5117,4.0322v31.7178h-12.6943Z",
    transform: "translate(-1022.0785 -400.3272)",
    style: {
      fill: "#212b54"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1309.7,466.389c0-7.1934-.102-12.3164-.4091-17.1123h10.9536l.41,10.1367h.4092c2.457-7.5205,8.292-11.335,13.6152-11.335a12.4652,12.4652,0,0,1,2.9688.3262v12.6436a16.492,16.492,0,0,0-3.6851-.4366c-6.04,0-10.1347,4.1426-11.2607,10.1368a24.4146,24.4146,0,0,0-.41,4.1425v27.4659H1309.7Z",
    transform: "translate(-1022.0785 -400.3272)",
    style: {
      fill: "#212b54"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390.7772,486.4437c0,6.3213.2051,11.5537.41,15.9131h-11.0562l-.6143-8.0655h-.2045a17.8668,17.8668,0,0,1-15.97,9.2647c-9.1113,0-17.4033-5.7774-17.4033-23.1065V449.2767h12.5918v28.8838c0,8.8281,2.6616,14.4961,9.3154,14.4961,5.0166,0,8.2925-3.8155,9.6231-7.1934a12.8854,12.8854,0,0,0,.7168-4.1426V449.2767h12.5913Z",
    transform: "translate(-1022.0785 -400.3272)",
    style: {
      fill: "#212b54"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1446.6785,466.7272",
    transform: "translate(-1022.0785 -400.3272)",
    style: {
      fill: "url(#ea0ab2fd-9d7c-46b6-a50a-91c41a54ceee)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9a761c88a9a4e72b56942a461e6ce579.svg";
export { ForwardRef as ReactComponent };